<template>
  <div v-if="error != null && typeof error != 'undefined'">
    <div v-if="typeof error == 'object'">
      <span v-for="(singleError, index) in error" :key="index" style="color:red;">{{singleError}}</span>
    </div>
    <span v-else style="color:red;">{{error}}</span>
  </div>

</template>

<script>
export default {
  name: 'ErrorBlock',
  props: {
    error: {
      type: Object,
      default: null
    }
  }
}
</script>
